import React, { useState } from "react";
import styled from "styled-components";
import AddCircleOutline from "@material-ui/icons/AddCircleOutline";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { HeaderBar } from "@sonder/ui/source/styled/fragments/HeaderBar";
import {
  Scroller,
  ScrollerContent,
} from "@sonder/ui/source/styled/fragments/Scroller";
import { CleaningCompanyFilters } from "schedule/components/Filters/CleaningCompanyFilters";
import QualityAuditsEmailConfigurationModal from "./QualityAuditsEmailConfigurationModal";

const StyledHeaderBar = styled(HeaderBar)`
  justify-content: flex-start;
  > *:not(:last-child) {
    margin-right: 0.6rem;
  }
`;

export const QualityAuditsEmailConfigurationHeader = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const handleHideModal = () => {
    setModalOpen(false);
  };

  return (
    <Scroller>
      <ScrollerContent>
        <StyledHeaderBar>
          <Button iconLeft type="button" onClick={() => setModalOpen(true)}>
            <AddCircleOutline />
            Add Configuration
          </Button>
          <QualityAuditsEmailConfigurationModal
            isOpen={isModalOpen}
            onClose={handleHideModal}
          />
          <CleaningCompanyFilters />
        </StyledHeaderBar>
      </ScrollerContent>
    </Scroller>
  );
};
